module.exports = __webpack_public_path__ + "05_glasses_black.7fd9c2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/05_glasses_black.png
// module id = yUnk
// module chunks = 0